export class Locales {
  static readonly PT_BR = "pt-BR";
  static readonly PT_PT = "pt-PT";
  static readonly EN_US = "en-US";
  static readonly EN_GB = "en-GB";
  static readonly FR_FR = "fr-FR";
  static readonly DE_DE = "de-DE";
  static readonly ES_ES = "es-ES";
  static readonly IT_IT = "it-IT";
  static readonly JA_JP = "ja-JP";
  static readonly KO_KR = "ko-KR";
  static readonly ZH_CN = "zh-CN";
  static readonly ZH_TW = "zh-TW";
  static readonly RU_RU = "ru-RU";
  static readonly AR_SA = "ar-SA";
  static readonly HE_IL = "he-IL";
}
